import { BaseTabs } from '@components';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { SharedPageWrapper } from '@routes/___shared___/styled.tsx';
import { PageHeader } from '@routes/profile-bar/___pages___/my-profile/styled.tsx';
import ProfileHeader from '@routes/sidebar/___shared___/components/profile-header';
import ConsentCenterList from '@routes/sidebar/settings/ui/consent-center-tab';
import UserPreferences from '@routes/sidebar/settings/ui/user-preferences-tab';
import { translateItem } from '@utils/translations.ts';
import type { TabsProps } from 'antd';

export const SHARED_SETTINGS_USER_PREFERENCES_TAB = msg`User preferences`;
export const SHARED_SETTINGS_CONSENT_CENTER_TAB = msg`Consent center`;

// needs to be a hook to use useLingui() safely
const useTabs = (): TabsProps['items'] => {
    return [
        {
            key: 'user preferences',
            label: translateItem(SHARED_SETTINGS_USER_PREFERENCES_TAB),
            children: <UserPreferences />,
        },
        {
            key: 'consent center',
            label: translateItem(SHARED_SETTINGS_CONSENT_CENTER_TAB),
            children: <ConsentCenterList />,
        },
    ];
};

const UserSettings = () => {
    const { t } = useLingui();
    const tabs = useTabs();

    return (
        <div>
            <SharedPageWrapper>
                <PageHeader>{t`Account Settings`}</PageHeader>
                <ProfileHeader />
                <BaseTabs defaultActiveKey="user preferences" items={tabs} />
            </SharedPageWrapper>
        </div>
    );
};

export default UserSettings;
